export const SCENE_BEFORE_PREFIX = 'sb__'
export const SCENE_CURSOR_PREFIX = 'sc__'
export const SCENE_AFTER_PREFIX = 'sa__'
export const SCENE_CURSOR_CHILD_PREFIX = 'sch__'

export const VERSE_BEFORE_PREFIX = 'vb__'
export const VERSE_CURSOR_PREFIX = 'vc__'
export const VERSE_AFTER_PREFIX = 'va__'
export const VERSE_CURSOR_CHILD_PREFIX = 'vch__'
